import React, { memo } from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel } from "@aureskonnect/react-ui";
import MultiCustomCreatableSelection from "@components/Common/MultiCustomCreatableSelection";
import { formatCreateLabel } from "../../hooks";

export const TagField = memo(
    ({ t, tagsData, setTagsData, tags, isSendingTag, setIsEdited }: any) => (
        <AvGroup>
            <StyledLabel htmlFor="text" className="mt-3">
                {t("Tag")}
            </StyledLabel>

            <MultiCustomCreatableSelection
                className="mdr_inp_FRtags"
                onDelete={() => setIsEdited(true)}
                isSendingTag={isSendingTag}
                setResult={setTagsData}
                result={tagsData}
                data={tags}
                onChange={() => setIsEdited(true)}
                onCreateOption={() => setIsEdited(true)}
                placeholder={`${t("Select")}…`}
                value={t("Choose")}
                name="tag"
                noOptionsMessage={() => t("No options")}
                formatCreateLabel={() => formatCreateLabel("", t("New tag"))}
            />
        </AvGroup>
    )
);
